import { QueryClient, QueryClientProvider, useQuery } from "@tanstack/react-query";
import { lazy, StrictMode, Suspense } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { LoadingWorkspace } from "./components/ui";
import { getPublicConfig } from "./lib/api";
import "./styles.css";

const Landing = lazy(() => import("./pages/Landing").then((module) => ({ default: module.Landing })));

const queryClient = new QueryClient({ defaultOptions: { queries: { retry: 1, refetchOnWindowFocus: false } } });

function Root() {
  const config = useQuery({ queryKey: ["public-config"], queryFn: getPublicConfig, staleTime: 60_000 });
  if (config.isLoading) return <LoadingWorkspace />;
  if (!config.data) return <main className="fatal-state"><strong>Workspace unavailable</strong><p>Configuration could not be loaded. Try again shortly.</p></main>;
  return <Suspense fallback={<LoadingWorkspace />}><Landing config={config.data} /></Suspense>;
}

createRoot(document.getElementById("root")!).render(
  <StrictMode><QueryClientProvider client={queryClient}><BrowserRouter><Root /></BrowserRouter></QueryClientProvider></StrictMode>
);

if ("serviceWorker" in navigator && import.meta.env.PROD) {
  window.addEventListener("load", () => navigator.serviceWorker.register("/sw.js").catch(() => undefined));
}
